import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Overview from './pages/Overview';
import UnitView from './pages/UnitView';
import DeviceLogs from './pages/DeviceLogs';
import NewReport from './pages/NewReport';
import CurrentReports from './pages/CurrentReports';
import NewAlert from './pages/NewAlert';
import CurrentAlerts from './pages/CurrentAlerts';
import Predictions from './pages/Predictions';
import AskAI from './pages/AskAI';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import Login from './pages/Login';
import AddNewDevice from './pages/AddNewDevice';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const pageProps = {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 },
    transition: { duration: 0.3 },
  };

  if (location.pathname === '/login') {
    return <Login />;
  }

  return (
    <div className="flex h-screen bg-mainbg text-white">
      <Sidebar
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
      />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onBurgerClick={() => setMobileOpen(true)} />
        <main className="relative flex-1 overflow-y-auto bg-mainbg p-4">
          <ErrorBoundary>
            <AnimatePresence mode="wait">
              <Routes location={location} key={location.pathname}>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<Login />} />
                <Route
                  path="/dashboard/overview"
                  element={<motion.div {...pageProps}><Overview /></motion.div>}
                />
                <Route
                  path="/dashboard/unit"
                  element={<motion.div {...pageProps}><UnitView /></motion.div>}
                />
                <Route
                  path="/dashboard/device-logs"
                  element={<motion.div {...pageProps}><DeviceLogs /></motion.div>}
                />
                <Route path="/dashboard/table" element={<Navigate to="/dashboard/device-logs" replace />} />
                <Route
                  path="/dashboard/add-device"
                  element={<motion.div {...pageProps}><AddNewDevice /></motion.div>}
                />
                <Route path="/reports/new" element={<motion.div {...pageProps}><NewReport /></motion.div>} />
                <Route path="/reports/current" element={<motion.div {...pageProps}><CurrentReports /></motion.div>} />
                <Route path="/alerts/new" element={<motion.div {...pageProps}><NewAlert /></motion.div>} />
                <Route path="/alerts/current" element={<motion.div {...pageProps}><CurrentAlerts /></motion.div>} />
                <Route path="/ai/predictions" element={<motion.div {...pageProps}><Predictions /></motion.div>} />
                <Route path="/ai/ask" element={<motion.div {...pageProps}><AskAI /></motion.div>} />
                <Route path="/settings" element={<motion.div {...pageProps}><Settings /></motion.div>} />
                <Route path="/profile" element={<motion.div {...pageProps}><Profile /></motion.div>} />
              </Routes>
            </AnimatePresence>
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}

export default App;
